import React from "react";
import { Link } from "react-router-dom";
import "../assets/generalTrade.css";

const BusinessGateway: React.FC = () => {
  return (
    <main className="lz-gateway">
      <div className="lz-gateway-shell">
        <div className="lz-gateway-grid">
          <Link
            to="/solutions"
            className="lz-gateway-card lz-gateway-card-solutions"
          >
            <div className="lz-gateway-logo-wrap">
              <img
                src="/images/general-trade/logo-lyrazone-solutions.png"
                alt="Lyra Zone Solutions"
              />
            </div>

            <span className="lz-gateway-enter">ICT Solutions</span>
          </Link>

          <Link
            to="/general-trade"
            className="lz-gateway-card lz-gateway-card-trade"
          >
            <div className="lz-gateway-logo-wrap">
              <img
                src="/images/general-trade/logo-lyrazone-general-trading.png"
                alt="Lyra Zone General Trading"
              />
            </div>

            <span className="lz-gateway-enter">General Trade</span>
          </Link>
        </div>

        {/* Animated Solutions streams */}
        <div
          className="gateway-energy-stream gateway-energy-solutions"
          aria-hidden="true"
        >
          <span className="energy-line energy-line-1" />
          <span className="energy-line energy-line-2" />
          <span className="energy-line energy-line-3" />
          <span className="energy-line energy-line-4" />
          <span className="energy-line energy-line-5" />
        </div>

        {/* Animated General Trade streams */}
        <div
          className="gateway-energy-stream gateway-energy-trade"
          aria-hidden="true"
        >
          <span className="energy-line energy-line-1" />
          <span className="energy-line energy-line-2" />
          <span className="energy-line energy-line-3" />
          <span className="energy-line energy-line-4" />
          <span className="energy-line energy-line-5" />
        </div>

        <div className="lz-gateway-success">
          <span>GATEWAY OF</span>
          <strong>SUCCESS</strong>
        </div>
      </div>
    </main>
  );
};

export default BusinessGateway;
